<span
  class="inline-flex"
  data-testid="resume-consultation-tooltip"
  [appTooltip]="(tooltip() ?? '') | translate"
  appTooltipPosition="above"
  appTooltipAlign="end">
  <button
    mat-stroked-button
    type="button"
    data-testid="resume-consultation-button"
    class="md:!h-9 md:!px-4 !text-sm !rounded-full md:!rounded-lg !w-10 md:!w-auto !h-10 !px-0 !min-w-0 md:!min-w-none"
    [disabled]="disabled()"
    (click)="onResume()">
    <span class="material-icons !text-base !mr-0 md:!mr-2 !text-primary">graphic_eq</span>
    <span class="hidden md:inline">{{ 'Resume' | translate }}</span>
  </button>
</span>
